import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";

const productData = [
  {
    // title: 'Product 1',
    // description: 'This is a description of product 1. It is a great product used by many customers.',
    imageUrl: "/assets/consumer1.png", // Replace with actual product image URL
  },
  {
    // title: 'Product 2',
    // description: 'This is a description of product 2. Customers love this product for its quality.',
    imageUrl: "/assets/consumer2.png", // Replace with actual product image URL
  },
  // {
  //   // title: 'Product 3',
  //   // description: 'This is a description of product 3. It is popular among our customers for its design.',
  //   imageUrl: '/assets/consumer3.jpeg',  // Replace with actual product image URL
  // },
  // {
  //   // title: 'Product 4',
  //   // description: 'Product 4 is known for its durability and high performance. A favorite choice for professionals.',
  //   imageUrl: '/assets/consumer4.jpeg',  // Replace with actual product image URL
  // },
  // {
  //   // title: 'Product 5',
  //   // description: 'This is product 5, a revolutionary gadget that has become a top seller in the market.',
  //   imageUrl: '/assets/consumer5.jpeg',  // Replace with actual product image URL
  // },
  {
    // title: 'Product 6',
    // description: 'Product 6 offers excellent value for money and is highly rated by our customers.',
    imageUrl: "/assets/consumer6.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 7',
    // description: 'Product 7 is perfect for those who appreciate sleek design and cutting-edge technology.',
    imageUrl: "/assets/consumer7.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 8',
    // description: 'An innovative product that has gained popularity for its unique features and ease of use.',
    imageUrl: "/assets/consumer8.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 9',
    // description: 'Product 9 is a customer favorite, praised for its stylish design and high performance.',
    imageUrl: "/assets/consumer9.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 7',
    // description: 'Product 7 is perfect for those who appreciate sleek design and cutting-edge technology.',
    imageUrl: "/assets/consumer10.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 8',
    // description: 'An innovative product that has gained popularity for its unique features and ease of use.',
    imageUrl: "/assets/consumer11.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 9',
    // description: 'Product 9 is a customer favorite, praised for its stylish design and high performance.',
    imageUrl: "/assets/consumer12.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 9',
    // description: 'Product 9 is a customer favorite, praised for its stylish design and high performance.',
    imageUrl: "/assets/consumer13.jpeg", // Replace with actual product image URL
  },
  {
    // title: 'Product 9',
    // description: 'Product 9 is a customer favorite, praised for its stylish design and high performance.',
    imageUrl: "assets/acid.jpeg", // Replace with actual product image URL
  },
];

const ProductOfConsumers = () => {
  return (
    <Box sx={{ padding: "40px 20px", backgroundColor: "#f5f5f5" }}>
      <Typography
        variant="h4"
        gutterBottom
        align="center"
        sx={{ marginBottom: "40px" }}
      >
        Products for Farmer
      </Typography>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ marginBottom: "20px", fontWeight: "700", fontSize: "22px" }}
      >
        Product Range For Farmers:
      </Typography>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ marginBottom: "10px", fontWeight: "500", fontSize: "18px" }}
      >
        Amino acid, Plantbase Natural Extract Hormone, Humic Acid-base Product, Preventive systemic organic pesticide, Organic Manure, etc.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {productData.map((product, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                maxWidth: 345,
                Height: 800,
                aspectRatio: 1,
                boxShadow: 3,
                padding: 2,
                display: "flex",
                flexDirection: "column",
                borderRadius: 2, // Rounded corners for a modern look
                transition: "transform 0.3s ease", // Hover effect for cards
                "&:hover": {
                  transform: "scale(1.05)", // Zoom in on hover
                },
              }}
            >
              <CardMedia
                component="img"
                height="250"
                image={product.imageUrl}
                alt={product.title}
                sx={{
                  objectFit: "contain", // Ensures the image covers the whole area
                  borderTopLeftRadius: 2, // Rounded top-left corners
                  borderTopRightRadius: 2, // Rounded top-right corners
                }}
              />
              {/* <CardContent>
                <Typography variant="h6" component="div" gutterBottom>
                  {product.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {product.description}
                </Typography>
              </CardContent> */}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProductOfConsumers;
